import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import axios from 'axios';
import { constants } from '../constants';
import currentUserContext from '../contexts/LIFFUserContext';

export default function ChatroomListGuard() {
  const navigate = useNavigate();
  const customerProfile = useContext(currentUserContext);
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const isInvitationLink = searchParams.has('join');
  const chatroomId = searchParams.get('join');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (customerProfile && token && isInvitationLink) {
      axios
        .get<{ redirectTo: string; isStarted: boolean }>(
          `${constants.endpoint}/users/${customerProfile?.userId}/visit`,
          {
            headers: {
              Authorization: `bearer ${token}`,
            },
            params: {
              chatroomId,
            },
          }
        )
        .then((response) => {
          navigate(`/chatrooms/${chatroomId}/landing`, {
            replace: true,
            state: {
              ...response.data,
            },
          });
        })
        .catch(console.error);
    } else {
      navigate('/chatrooms', { replace: true });
    }
  }, [chatroomId, customerProfile, isInvitationLink, navigate]);

  return <></>;
}
